"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _react = _interopRequireDefault(require("react"));
class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    console.error(error);
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Sorry, something went wrong with this chart.");
    }
    return this.props.children;
  }
}
exports.ErrorBoundary = ErrorBoundary;